import { ReactNode } from 'react';

export interface IndeedChildrenProps {
    children?: ReactNode[] | ReactNode;
}

export interface IndeedPaperProps extends IndeedChildrenProps {
    style?: React.CSSProperties | undefined;
}

export interface TandemFreeIconTextProps extends IndeedChildrenProps {
    icon: React.ReactNode;
}

export interface NextStepType {
    icon: React.ReactNode;
    text: string;
    title?: string;
    gridStyle?: React.CSSProperties;
}

export interface JobAccessorProps {
    jobAccessor: string;
    onLoadFail: () => void;
}

export interface IndeedFormProps {
    userCreated: boolean;
    onUserCreated: () => void;
}

export interface IndeedTopCardProps extends JobAccessorProps, IndeedFormProps {}

export interface NextStepsModalProps {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
}

export const APP_LINK = `https://apps.apple.com/app/apple-store/id1491607600?pt=120819140&ct=InviteFriends&mt=8`;
